import React from 'react';
import Reveal from './Reveal';

const SectionHeader = ({ eyebrow, title, accent, subtitle, align = 'left' }) => (
  <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && (
      <Reveal>
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyan-400/30 bg-cyan-400/5 text-cyan-300 text-xs font-medium uppercase tracking-widest mb-4`}>
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
          {eyebrow}
        </div>
      </Reveal>
    )}
    <Reveal delay={80}>
      <h2 className="font-display text-4xl md:text-5xl font-bold text-white leading-[1.05]">
        {title} {accent && <span className="shimmer-text">{accent}</span>}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={160}>
        <p className="text-white/60 text-base md:text-lg leading-relaxed mt-5">{subtitle}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeader;
